import React from "react";
import Home from "./pagina-principal/home.jsx";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Cuenta from "./pagina-principal/miperfil.jsx";
import Registro from "./pagina-principal/registro.jsx";
import Login from "./pagina-principal/login.jsx";
import Crearaventura from "./pagina-principal/crear-aventura.jsx";
import Mapa from "./pagina-principal/mapa.jsx";
import Aventuras from "./pagina-principal/aventuras.jsx";
import Veraventura from "./pagina-principal/veraventura.jsx";
import DisenoAmigos from "./pagina-principal/diseno-amigos.jsx";
import OlvideContrasena from "./pagina-principal/olvidemicontrasena.jsx";
import CambiarContrasena from "./pagina-principal/cambiarContrasena.jsx";
import ModificarAventura from "./pagina-principal/modificaraventura.jsx";
import Iframewidget from "./pagina-principal/iframewidget.jsx";
import Landing from "./pagina-principal/landing.jsx";
import TerminsoyCondiciones from "./pagina-principal/terminosycondicones.jsx";
import RevisarAventuras from "./pagina-principal/admin/revisarAventuras.jsx";
import TerminosySeguridad from "./pagina-principal/terminosyseguridad.jsx";
import DisenoAdmin from "./pagina-principal/admin/disenoadmin.jsx";
import ModerarUsuarios from "./pagina-principal/admin/moderarusuarios.jsx";
import DisenoEmpresas from "./pagina-principal/empresas/disenoempresas.jsx";
import AventurasPublicadas from "./pagina-principal/empresas/aventuras-publicadas.jsx";
import DetalleAventura from "./pagina-principal/empresas/detalle-aventura.jsx";
import RegistroEmpresas from "./pagina-principal/empresas/registroEmpresas.jsx";
import RegistroGuiasDeTurismo from "./pagina-principal/empresas/registroGuiasdeTurismo.jsx";
import InformacionCuenta from "./pagina-principal/empresas/informacion-cuenta.jsx";
import RedireccionPerfil from "./pagina-principal/empresas/redireccion_perfil.jsx";
import PublicarAventuras from "./pagina-principal/empresas/publicarAventuras.jsx";
import "./css/global.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cuenta" element={<Cuenta />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/iniciar-sesion" element={<Login />} />
        <Route
          path="/olvide-mi-contrasena"
          element={<OlvideContrasena />}
        ></Route>
        <Route path="/amigos" element={<DisenoAmigos />} />
        <Route path="/crear-aventura" element={<Crearaventura />} />
        <Route
          path="/aventuras/:id/:nombreaventura/editar"
          element={<ModificarAventura />}
        />
        <Route path="/mapa" element={<Mapa />} />
        <Route path="/aventuras" element={<Aventuras />} />
        <Route
          path="/aventuras/:id/:nombreaventura"
          element={<Veraventura />}
        />
        <Route
          path="/recuperar-contrasena/:id/:token"
          element={<CambiarContrasena />}
        />
        <Route path="/landing" element={<Landing />}></Route>
        <Route
          path="/terminos-condiciones"
          element={<TerminsoyCondiciones />}
        ></Route>
        <Route
          path="/terminos-seguridad"
          element={<TerminosySeguridad />}
        ></Route>
        <Route
          path="/panel/administracion/moderar-aventuras"
          element={<RevisarAventuras />}
        ></Route>
        <Route
          path="/panel/administracion/moderar-usuarios"
          element={<ModerarUsuarios />}
        ></Route>
        <Route path="/panel/administracion" element={<DisenoAdmin />}></Route>
        <Route path="/panel/escritorio" element={<DisenoEmpresas />}></Route>
        <Route
          path="/panel/escritorio/aventuras-publicadas"
          element={<AventurasPublicadas />}
        ></Route>
        <Route
          path="/panel/escritorio/aventuras-publicadas/detalle"
          element={<DetalleAventura />}
        ></Route>
        <Route
          path="/panel/escritorio/registro"
          element={<RegistroEmpresas />}
        ></Route>
        <Route
          path="/panel/escritorio/registro-guias-de-turismo-aventura"
          element={<RegistroGuiasDeTurismo />}
        ></Route>
        <Route
          path="/panel/escritorio/cuenta"
          element={<RedireccionPerfil />}
        ></Route>
        <Route
          path="/panel/escritorio/publicar"
          element={<PublicarAventuras />}
        ></Route>
      </Routes>
    </Router>
  );
}

export default App;
